import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { API } from '../api/notary.service';
import { AuthService } from './auth.service';

/** Adds the session token to API calls, and signs out locally when the API rejects it. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Never hand the token to any other host (e.g. the S3 presigned URLs).
  if (!req.url.startsWith(`${API}/`)) return next(req);
  const auth = inject(AuthService);
  return from(auth.accessToken()).pipe(
    switchMap((token) =>
      next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req),
    ),
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) void auth.dropSession();
      return throwError(() => err);
    }),
  );
};
